/**
 * BASSERS® OUTFIT — カート: − / + / Delete で /cart/change.js を呼び、完了後にページを再描画
 */
(function () {
  function init(root) {
    if (root.__outfitCart) return;
    root.__outfitCart = true;
    var errorEl = root.querySelector('[data-outfit-cart-error]');

    function change(line, quantity) {
      root.classList.add('is-busy');
      fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.message) {
            if (errorEl) { errorEl.textContent = res.message; errorEl.hidden = false; }
            root.classList.remove('is-busy');
            return;
          }
          window.location.reload();
        })
        .catch(function () {
          if (errorEl) { errorEl.textContent = (window.cartStrings && window.cartStrings.error) || 'Error'; errorEl.hidden = false; }
          root.classList.remove('is-busy');
        });
    }

    root.querySelectorAll('[data-outfit-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.getAttribute('data-line'), 10);
        var input = root.querySelector('[data-outfit-qty-input][data-line="' + line + '"]');
        var current = parseInt(input.value, 10) || 0;
        var next = Math.max(0, current + parseInt(btn.getAttribute('data-outfit-qty-change'), 10));
        input.value = next;
        change(line, next);
      });
    });
    root.querySelectorAll('[data-outfit-qty-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        change(parseInt(input.getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0));
      });
    });
    root.querySelectorAll('[data-outfit-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        change(parseInt(btn.getAttribute('data-outfit-remove'), 10), 0);
      });
    });
  }
  function boot() { document.querySelectorAll('[data-outfit-cart]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
